import cx from 'classix'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import useNavigationProgramsTabData from '@components/hooks/useNavigationProgramsTabData'

import i18n from '@src/config/i18n'

import { getProgramsTabs, ProgramTab } from '../constants/programs'
import TimedSectionsLinkGrid from '../content/TimedSectionsLinkGrid'
import MegaMenu from '../menu/MegaMenu'
import MegaMenuContent from '../menu/MegaMenuContent'

type Props = {
  open: boolean
}

export default function ProgramsTabMenu({ open }: Props) {
  const [selectedTab, setSelectedTab] = useState<ProgramTab>(ProgramTab.TOPIC)
  const { t } = useTranslation('revamp')
  const locale = i18n.language

  const programsTabData = useNavigationProgramsTabData()
  const programTabs = getProgramsTabs(t, locale, programsTabData)

  useEffect(() => {
    if (open) {
      setSelectedTab(ProgramTab.TOPIC)
    }
  }, [open])

  return (
    <MegaMenu open={open}>
      <section className='flex flex-col items-start w-2/5'>
        <div className='flex flex-col items-start gap-8 text-r-3xl font-bold leading-none text-revamp-red-100'>
          {programTabs.map((tab) => (
            <button
              key={`trainings_tab_${tab.name}`}
              className={cx(
                'text-left font-bold underline-thick',
                selectedTab === tab.key && 'text-white underline'
              )}
              onClick={() => setSelectedTab(tab.key)}
              onMouseEnter={() => setSelectedTab(tab.key)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </section>
      <MegaMenuContent>
        <TimedSectionsLinkGrid
          sections={programTabs[selectedTab].sections}
          button={programTabs[selectedTab].button}
        />
      </MegaMenuContent>
    </MegaMenu>
  )
}
